export default {
    mounted() {
        this.$nuxt.$on('logged', () => {
            if (this.$route.query.provider) {
                this.connectAccount()
            }
        })
    },
    methods: {
        async connectAccount() {
            try {
                await this.$axios.$get(`/?p=social_login_facebook_api_v1&method=connect`)
                .then((response) => {
                    if (response.status === 'success') {
                        console.info('Conta associada')
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
            } catch (error) {
                console.error(error)
            }
        }
    }
}
